// extracted by css-extract-rspack-plugin
export default {"root":"KQ1sl"};